import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { IPO } from 'src/types/PO';
import { IPostBody } from 'src/types/PostBody';
import axiosInstance from 'src/utils/axios';

export interface PoListResponse {
  items: IPO[];
  totalRecords: number;
}

async function fetchPoList(
  companyId: string,
  postBody: IPostBody,
  itemNumber?: string
): Promise<PoListResponse> {
  const response = await axiosInstance.post<PoListResponse>(
    api.filterPo(companyId, itemNumber),
    postBody
  );
  return response.data;
}

export interface UsePoListQueryOptions {
  companyId: string;
  postBody: IPostBody;
  itemNumber?: string;
}

export function usePoListQuery({ companyId, postBody, itemNumber }: UsePoListQueryOptions) {
  return useQuery<PoListResponse>({
    queryKey: queryKeys.po.poList(companyId, postBody, itemNumber),
    queryFn: () => fetchPoList(companyId, postBody, itemNumber),
    enabled: Boolean(companyId),
  });
}
